<template>
  <div class="d-flex justify-center">
    <div class="_temp_list">
      <div v-if="dataSet">
        <v-card class="rounded-lg mb-3" elevation="1">
          <section class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="$router.go(-1)" icon
                  ><v-icon>mdi-reply</v-icon></v-btn
                >
              </template>
              <span>Back</span>
            </v-tooltip>
            <router-link
              v-if="dataSet.data_author.role === 'SCHOLAR'"
              class="opener_name d-flex pa-3"
              :to="`/scholar/${dataSet.data_author.id}`"
            >
              <v-avatar class="mr-3">
                <img
                  :src="
                    dataSet.data_author.profile_picture
                      ? dataSet.data_author.profile_picture
                      : ava
                  "
                  class="obj_fit"
                  alt=""
                />
              </v-avatar>
              <div>
                <h4 class="black--text">{{ dataSet.data_author.name }}</h4>

                <small class="grey--text">{{
                  $date(dataSet.created_at).fromNow()
                }}</small>
              </div>
            </router-link>
            <div class="d-flex pa-3" v-else>
              <v-avatar class="mr-3">
                <img
                  :src="
                    dataSet.data_author.profile_picture
                      ? dataSet.data_author.profile_picture
                      : ava
                  "
                  class="obj_fit"
                  alt=""
                />
              </v-avatar>
              <div>
                <h4 class="black--text">{{ dataSet.data_author.name }}</h4>
                <small class="grey--text">{{
                  $date(dataSet.created_at).fromNow()
                }}</small>
              </div>
            </div>
            <!-- <div class="d-flex pa-3">
              <v-avatar class="mr-3">
                <img
                  :src="
                    dataSet.data_author.profile_picture
                      ? dataSet.data_author.profile_picture
                      : ava
                  "
                  class="obj_fit"
                  alt=""
                />
              </v-avatar>
              <div>
                <h4>{{ dataSet.data_author.name }}</h4>
                <small class="grey--text">{{
                  $date(dataSet.created_at).fromNow()
                }}</small>
              </div>
            </div> -->
          </section>
          <section class="px-5">
            <h3>{{ dataSet.title }}</h3>
          </section>
          <v-img
            v-if="dataSet.thumbnail"
            :src="dataSet.thumbnail"
            class="img-fit"
          ></v-img>
          <div class="pa-3">
            <article v-html="dataSet.content"></article>
          </div>
          <v-card-actions class="pa-2 d-flex justify-end">
            <v-card
              outlined
              class="rounded-lg d-flex"
              v-if="dataSet.user_id == id"
            >
              <v-tooltip top color="#006341">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    :color="dataSet.status == 1 ? 'blue' : ''"
                    @click="switchStatus(dataSet)"
                  >
                    <v-icon v-if="dataSet.status == 1">
                      mdi-toggle-switch
                    </v-icon>
                    <v-icon v-else> mdi-toggle-switch-off-outline </v-icon>
                  </v-btn>
                </template>
                <span v-if="dataSet.status == 1">Inactivate Thread</span>
                <span v-else>Activate Thread</span>
              </v-tooltip>

              <v-tooltip top color="#006341">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    color="blue"
                    @click="updateThread(dataSet)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit Thread</span>
              </v-tooltip>
              <v-tooltip top color="#006341">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    @click="deleteThread(dataSet)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete Thread</span>
              </v-tooltip>
            </v-card>
          </v-card-actions>
        </v-card>
        <comment-thread-facilitator class="mt-3" />
        <div class="pa-3">
          <dialog-large
            :d_large="d_large"
            @close="d_large = false"
            @refetch="fetchData"
            :type="d_type"
            :inventory="inventory"
            :title="d_title"
          />
          <dialog-small
            :d_small="d_small"
            @close="d_small = false"
            @refetch="fetchData"
            :type="d_type"
            :inventory="inventory"
            :title="d_title"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import DialogLarge from "../../../dialog/dialogLarge.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
import CommentThreadFacilitator from "./comment/commentThreadFacilitator.vue";
export default {
  name: "threadFacilitator",
  components: { DialogSmall, CommentThreadFacilitator },
  computed: {
    ...mapState({
      id: (state) => state.id,
      ava: (state) => state.ava,
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  data() {
    return {
      d_create: false,
      d_large: false,
      d_small: false,
      d_type: "",
      d_title: "",
      inventory: null,
      dataSet: null,
      loading: false,
      total: null,
      last_page: null,
      find: "",
      limit: 10,
      page: 1,
      switch: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.switch) {
        this.$router.back();
      } else {
        this.loading = true;
        let data = {
          path: `forum/administrator/${this.$route.params.idCourse}?type=fasilitator&filter[id]=${this.$route.params.idThread}`,
        };
        this.$store.dispatch("course/getData", data).then((data) => {
          this.loading = false;
          this.dataSet = data.data[0];
        });
      }
    },
    updateThread(item) {
      this.d_type = "uf_thread";
      this.inventory =  JSON.parse(JSON.stringify(item));
      this.d_large = true;
      this.d_title = "Update Thread";
    },
    deleteThread(item) {
      this.d_type = "df_thread";
      this.inventory = item;
      this.d_title = "Delete Thread";
      this.d_small = true;
    },
    switchStatus(item) {
      this.d_type = "switchf_thread";
      this.inventory = item;
      this.d_title = "";
      this.d_small = true;
      this.switch = true;
    },
  },
};
</script>

<style></style>
